<template>
  <div class="login-wrapper">
    <div class="bg-decor"></div>
    <div class="bg-animated"></div>
    <div class="brand">
     
      <div class="brand-text">
        <div class="brand-title">医药商城后台</div>
        <div class="brand-subtitle">微信小程序管理中心</div>
      </div>
    </div>
    <el-card class="login-card" shadow="always">
      <div class="login-title">欢迎登录</div>
      <el-form :model="form" :rules="rules" ref="formRef" label-width="0">
        <el-form-item prop="username">
          <el-input v-model="form.username" placeholder="请输入账号" prefix-icon="el-icon-user" autocomplete="off" />
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="form.password" placeholder="请输入密码" prefix-icon="el-icon-lock" type="password" autocomplete="off" @keyup.enter.native="login" />
        </el-form-item>
        <div class="form-actions">
          <el-checkbox v-model="remember">记住我</el-checkbox>
          <el-link type="primary">忘记密码</el-link>
        </div>
        <el-button class="login-btn" type="primary" @click="login" :loading="loading">登录</el-button>
      </el-form>
      <div class="login-footer">版权所有 © 医药商城后台</div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'AdminLogin',
  data() {
    return {
      loading: false,
      remember: true,
      form: {
        username: '',
        password: ''
      },
      rules: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      }
    }
  },
  methods: {
    login() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) return
        this.loading = true
        setTimeout(() => {
          if (this.form.username === 'admin' && this.form.password === '1') {
            localStorage.setItem('wxshop_token', 'mock-token')
            this.$message.success('登录成功')
            const redirect = this.$route.query.redirect || '/products'
            this.$router.replace(redirect)
          } else {
            this.$message.error('账号或密码错误')
          }
          this.loading = false
        }, 600)
      })
    }
  }
}
</script>

<style>
body,html {
  margin: 0;
  padding: 0;
  height: 100%;
}
.login-wrapper {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: linear-gradient(135deg, #e3efff 0%, #c7e2ff 45%, #e6fff0 100%);
  position: relative;
  overflow: hidden;
}
.login-card {
  width: 380px;
  border-radius: 12px;
  position: relative;
  z-index: 1;
}
.login-title {
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
}
.brand {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  color: #1f2d3d;
  position: relative;
  z-index: 1;
}
.brand-logo {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: #409eff;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin-right: 10px;
  box-shadow: 0 6px 16px rgba(64,158,255,.3);
}
.brand-text .brand-title {
  font-size: 26px;
  font-weight: 800;
  line-height: 1.15;
  letter-spacing: .4px;
}
.brand-text .brand-subtitle {
  font-size: 14px;
  color: #657487;
  margin-top: 4px;
  letter-spacing: .3px;
}
.brand-text {
  display: flex;
  flex-direction: column;
}
.form-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
}
.login-btn {
  width: 100%;
  background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
  border: none;
}
.login-footer {
  text-align: center;
  color: #909399;
  font-size: 12px;
  margin-top: 12px;
}
.bg-decor {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  z-index: 0;
  background-image:
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='160' height='160' viewBox='0 0 160 160'%3E%3Cg fill='none' stroke='%2390caf9' stroke-opacity='0.2'%3E%3Ccircle cx='80' cy='80' r='24'/%3E%3Cpath d='M80 36v16M80 88v36M36 80h16M108 80h16'/%3E%3C/g%3E%3C/svg%3E");
  background-size: 200px 200px;
  opacity: 1;
}
.bg-decor::before {
  content: '';
  position: absolute;
  width: 640px;
  height: 640px;
  left: -120px;
  top: -160px;
  background: radial-gradient(circle at 50% 50%, rgba(64,158,255,.6), rgba(64,158,255,0) 60%);
  filter: blur(20px);
  animation: float1 16s ease-in-out infinite alternate;
}
.bg-decor::after {
  content: '';
  position: absolute;
  width: 560px;
  height: 560px;
  right: -140px;
  bottom: -160px;
  background: radial-gradient(circle at 50% 50%, rgba(103,194,58,.55), rgba(103,194,58,0) 60%);
  filter: blur(18px);
  animation: float2 18s ease-in-out infinite alternate;
}
.bg-animated {
  position: absolute;
  inset: 0;
  z-index: 0;
  pointer-events: none;
  background: linear-gradient(135deg, rgba(64,158,255,.22), rgba(103,194,58,.18), rgba(255, 255, 255, .0));
  background-size: 200% 200%;
  animation: gradientFlow 16s ease-in-out infinite;
  mix-blend-mode: multiply;
}
.bg-animated::before {
  content: '';
  position: absolute;
  left: 50%;
  top: 50%;
  width: 800px;
  height: 800px;
  transform: translate(-50%, -50%);
  background: radial-gradient(circle at 50% 50%, rgba(0,0,0,.08), rgba(0,0,0,0) 60%);
}
@keyframes float1 {
  0% { transform: translate(0, 0) }
  50% { transform: translate(30px, 20px) }
  100% { transform: translate(60px, -10px) }
}
@keyframes float2 {
  0% { transform: translate(0, 0) }
  50% { transform: translate(-20px, -30px) }
  100% { transform: translate(-50px, 10px) }
}
@keyframes gradientFlow {
  0% { background-position: 0% 50% }
  50% { background-position: 100% 50% }
  100% { background-position: 0% 50% }
}
</style>
